export const SET_COTACOES_ACTION = 'cotacoes';
export const SET_VIEW_TYPE_ACTION = 'viewType';
export const SET_STATUS_ACTION = 'selectedStatus';
export const SET_FORNECEDORES_ACTION = 'fornecedores';
export const SET_COTACOES_ITENS_ACTION = 'cotacoesItens';
export const SET_SHOW_ESPECIFICACAO_ACTION = 'showEspecificacao';
export const SET_SHOW_ESPECIFICACAO_FORNECEDOR_ACTION = 'showEspecificacaoFornecedor';
export const SET_SHOW_PRECO_SEM_ICMS_ACTION = 'showPrecoSemIcms';
export const SET_TIPO_VISUALIZACAO_ACTION = 'tipoVisualizacao';
export const SET_SHOW_PERCENTUTAL_ICMS_ACTION = 'showPercentualIcms';
export const SET_SHOW_PRECO_TARGET_ACTION = 'showPrecoTarget';
export const CLEAR_ACTION = 'clear';
